export default __webpack_public_path__ + "static/media/bojo_m.c4afa373.jpg";